import type { NuxtApp } from '#app/nuxt'

const pendingRequests = new Map<string, Promise<any>>()

export default <ResT>(key: string, ttlInSeconds: number, handler: (ctx?: NuxtApp) => Promise<ResT>, options?: any) => {
    return useAsyncData(
        key,
        (nuxtApp) => {
            if (process.server) {
                return handler(nuxtApp)
            }

            if (pendingRequests.has(key)) {
                return pendingRequests.get(key)!
            }

            const promise = handler(nuxtApp).finally(() => {
                pendingRequests.delete(key)
            })

            pendingRequests.set(key, promise)
            return promise
        },
        {
            ...options,
            transform(input) {
                return {
                    ...input,
                    fetchedAt: new Date(),
                }
            },
            getCachedData(key: string, nuxtApp: NuxtApp) {
                const data = nuxtApp.payload.data[key] || nuxtApp.static.data[key]
                if (!data) {
                    return
                }

                if (nuxtApp.isHydrating) {
                    return data
                }

                // Is the data too old?
                const expirationDate = new Date(data.fetchedAt)
                expirationDate.setTime(expirationDate.getTime() + ttlInSeconds * 1000)
                const isExpired = expirationDate.getTime() < Date.now()
                if (isExpired) {
                    return
                }

                return data
            },
        }
    )
}
